export default {
    getCurrentUser: (state) => state.currentUser,
    GET_BANK_INFO: (state) => state.bankDetails
}
